import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { PlatformService } from '../../services/platform.service';

@Directive({
    selector: '[InputNumber]',

})
export class InputNumberDirective implements AfterViewInit {
  private _el = inject(ElementRef);
  private _platform = inject(PlatformService);


  ngAfterViewInit(): void {
    if (!this._platform.isBrowser) return;
    const regEx = new RegExp('[0-9,.]');
    this._el.nativeElement.addEventListener('keypress', (event) => {
      const char = event.key !== undefined ? event.key : String.fromCharCode(event.keyCode);
      if (!regEx.test(char)) {
        event.preventDefault();
      }
    });
  }
}
